import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import { getYearlyDataYear } from "services";

import { DEFAULT_CACHE_TIME, GET_YEARLY_DATA_YEAR } from "consts";

/**
 * @deprecated Use useGetFarmReportingYear instead
 * This hook can be used to fetch the current yearly data year of a farm.
 */
export const useCurrentYearlyDataYear = (farmId: string) => {
  const query = useQuery<number>({
    queryKey: [GET_YEARLY_DATA_YEAR, farmId],
    queryFn: () => getYearlyDataYear({ farmId }),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });

  return {
    year: query.data ?? moment().year(),
    refetch: query.refetch,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isFetched: query.isFetched,
  };
};
